import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cryptoPrecision'
})
export class CryptoPrecisionPipe implements PipeTransform {

  transform(value: number, currencyCode: string, targetCurrency?: string): string {
    if (!currencyCode || value === null || value === undefined) {
      return value?.toString() || '';
    }

    const code = currencyCode.toUpperCase();
    let precision = '1.2-2'; // Varsayılan precision

    // Bitcoin ve Ethereum için daha yüksek precision
    if (code === 'BTC' || code === 'ETHEREUM') {
      precision = '1.6-8';
    } else if (['DZD', 'XOF'].includes(targetCurrency)) {
      precision = '1.3-3';
    }

    const parts = precision.split('-');
    const minDigits = parseInt(parts[0].split('.')[1]);
    const maxDigits = parseInt(parts[1]);

    return value.toLocaleString('en-US', {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits
    });
  }
}
